import { getStoredUser } from './authStorage';

const PROFILE_STORAGE_KEY = 'webmonitor_profile_v1';

export const defaultProfile = {
  name: '',
  title: '',
  company: '',
  email: '',
  phone: '',
  timezone: '',
  plan: '',
  seats: '',
  created: '',
  avatar: '',
};

const readStorage = () => {
  if (typeof window === 'undefined') return null;
  try {
    const data = window.localStorage.getItem(PROFILE_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

const writeStorage = (payload) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PROFILE_STORAGE_KEY, JSON.stringify(payload));
    window.dispatchEvent(new Event('profile-updated'));
  } catch {
    // ignore storage errors
  }
};

export const getStoredProfile = () => {
  const stored = readStorage();
  const profile = stored ? { ...defaultProfile, ...stored } : { ...defaultProfile };
  const authUser = getStoredUser();

  if (authUser) {
    const fallbackName =
      authUser.fullName ||
      authUser.username ||
      (authUser.email ? authUser.email.split('@')[0] : '');

    if (!profile.name) {
      profile.name = fallbackName || '';
    }

    if (!profile.email) {
      profile.email = authUser.email || '';
    }

    // Sync profilePicture from user data to avatar field (always sync, even if empty)
    if (authUser.hasOwnProperty('profilePicture')) {
      profile.avatar = authUser.profilePicture || '';
    }
  }

  return profile;
};

export const saveProfile = (profile) => {
  const merged = { ...defaultProfile, ...profile };
  writeStorage(merged);
  return merged;
};

export const clearProfile = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(PROFILE_STORAGE_KEY);
  window.dispatchEvent(new Event('profile-updated'));
};

